<script setup>
import ImgMedia from "@/Components/Images/ImgMedia.vue";
import {inject} from "vue";
import Link from "@/Components/Buttons/Link.vue";

const dayjs = inject('dayjs');
const route = inject('route');
defineProps({
  blog: Object
});
</script>

<template>
    <div
        class="inner-container relative my-15 w-full "
    >
        <div
            class="relative flex  aspect-[1792/580] w-full bg-grey-dark"
        >
            <ImgMedia
                v-if="blog.featured_image"
                eager
                :media="blog.featured_image"
                classes="absolute inset-0 h-full w-full object-cover"
            />
        </div>
        <p class="my-4">
            {{ dayjs(blog.published_at).format('DD MMMM YYYY') }}
        </p>
        <h2 class="mb-4 text-xl font-bold uppercase lg:text-4xl">
            {{ blog.title }}
        </h2>
        <p class="mb-8">
            {{ blog.excerpt }}
        </p>

        <div class="flex-center">
            <Link
                :href="route('public.blogs.show', blog.page_slug)"
                :label="$t('Read more')"
            />
        </div>
    </div>
</template>
